<template>
  <div class="relative">
    <svg class="fixed top-0 left-96 transform -translate-x-32 sm:-translate-x-16 md:translate-x-36 lg:translate-x-72 xl:translate-x-96 translate-y-8" width="640" height="784" fill="none" viewBox="0 0 640 780">
      <defs>
        <pattern id="snowflake-sidebar" width="20" height="20" viewBox="0 0 16 16" patternUnits="userSpaceOnUse">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.24768 10.2629L6 9.85742L6.30904 8.90637L7.55668 9.31179V8H8.55668V9.31179L9.80429 8.90637L10.1133 9.85742L8.86568 10.2628L9.63676 11.3242L8.82774 11.9119L8.05668 10.8507L7.28562 11.9119L6.4766 11.3242L7.24768 10.2629Z" class="text-gray-200" fill="currentColor"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.24768 3.26285L1 2.85742L1.30904 1.90637L2.55668 2.31179V1H3.55668V2.31179L4.80429 1.90637L5.11333 2.85742L3.86568 3.26285L4.63676 4.32415L3.82774 4.91193L3.05668 3.85065L2.28562 4.91193L1.4766 4.32415L2.24768 3.26285Z" class="text-gray-200" fill="currentColor"/>
        </pattern>
      </defs>
      <rect y="72" width="640" height="440" class="text-gray-50" fill="currentColor" />
      <rect x="118" width="404" height="680" fill="url(#snowflake-sidebar)" />
    </svg>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>
